import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "English",
    fallbackLng: "English",
    interpolation: {
      escapeValue: false
    },
    detection:{
      order:['sessionStrorage','navigator'],
      lookupSessionStorage:'user',
      caches:[]
    }
  });

export default i18n;
